// dev/stg đặt REACT_APP_CAPTCHA_REQUIRED=false: widget vẫn hiện nhưng không bắt tick mới submit được.
// Không dùng REACT_APP_LANDING_PAGE_CAPTCHA_SITE_KEY trong .env gốc (của ha-landing-page): Nx nạp nó vào mọi app.
// Production luôn bắt tick, thiếu key thì báo lỗi ngay chứ không lặng lẽ mở form không có captcha.
const isProduction = process.env.REACT_APP_ENV === 'production';

export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY || '';

export const isCaptchaRequired = isProduction || process.env.REACT_APP_CAPTCHA_REQUIRED !== 'false';

if (isProduction && !CAPTCHA_SITE_KEY) {
  throw new Error('Thiếu REACT_APP_CAPTCHA_SITE_KEY cho production');
}
